module.exports = __webpack_public_path__ + "media/images/id_verif-7fa55f0ccd898ab23e5ba817395930b5.svg";